<template>
	<div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<div class="pageTit">
			<span>课程报名中心</span>
		</div>
		<!-- 筛选 -->
		<div class="shaixuan">
			<div class="catBox">
				<div class="cat flex" style="flex-wrap: nowrap;margin-bottom: 0.1rem;">
					<div class="tit" style="padding-top: 0.04rem;">方向:</div>
					<div class="f-ct" style="width: calc(100% - 1rem);">
						<div class="itm" style="margin-bottom: 0.1rem;" @click="selCat(itm)" :class="catIdx==itm.id?'a':''" v-for="(itm,idx) in catArr">{{itm.categoryName}}</div>
					</div>
				</div>
				<div class="cat flex" style="flex-wrap: nowrap;margin-bottom: 0rem;">
					<div class="tit" style="padding-top: 0.04rem;">分类:</div>
					<div class="f-ct" style="width: calc(100% - 1rem);">
						<div class="itm" style="margin-bottom: 0.1rem;" @click="selCat1(itm.id)" :class="catIdx1==itm.id?'a':''" v-for="(itm,idx) in catArr1">{{itm.categoryName}}</div>
					</div>
				</div>
			</div>
			<div class="seach f-ct">
				<div class="iptBox f-ct">
					<div class="ipt">
						<el-input type="text" v-model="keyword" placeholder="请输入搜索关键词"></el-input>
					</div>
				</div>
				<div class="seachBtn f-ct">
					<div @click="courselist(1)">搜索</div>
					<div @click="keyword='',courselist(1)">重置</div>
				</div>
			</div>
		</div>
		<!-- 表格 -->
		<div class="zw" v-if="!msgList.length">
			<el-image :src="require('@/static/zw.png')"></el-image>
			<p>暂无相关数据...</p>
		</div>
		<div class="biaoge" v-if="msgList.length">
			<div class="table">
				<div class="th f-ct">
					<p class="t1">序号</p>
					<p class="t2">课程名称</p>
					<p class="t3">课程类型</p>
					<p class="t4">学时</p>
					<p class="t5">收费标准</p>
					<p class="t6">报名人数</p>
					<p class="t7">缴费人数</p>
					<p class="t8">未缴费人数</p>
					<p class="t9">操作</p>
				</div>
				<div class="td f-ct" v-for="(item,index) in msgList">
					<p class="t1">{{item.id}}</p>
					<p class="t2">{{item.name}}</p>
					<p class="t3">{{item.categoryName}}</p>
					<p class="t4">{{item.studyHours}}</p>
					<p class="t5 red">￥{{item.price}}</p>
					<p class="t6" @click="link('/qyClassMan',{id:item.id})">{{item.companyTotalMemberNum}}</p>
					<p class="t7" @click="link('/qyClassMan1',{id:item.id})">{{item.companyPaidMemberNum}}</p>
					<p class="t8" @click="link('/qyClassMan2',{id:item.id})">{{item.companyNotPayMemberNum}}</p>
					<p class="t9 blue" @click="link('/qyClassManAdd',{id:item.id,isRecheck:item.isRecheck})">增加报名</p>
				</div>
			</div>
			<div class="fenye">
			<el-pagination
			background
			hide-on-single-page
			layout="prev, pager, next,jumper"
			@current-change="goPage"
			:page-size="pageSize"
			:total="total">
			</el-pagination>
			</div>	
		</div>
		
		</div>
	</div>
</template>
<script>
import { coursecategoryList,courselist,coursedetail,courseappliedCourseList } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			catArr:[],
			catArr1:[],
			catIdx:0,
			catIdx1:0,
			keyword:'',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			msgList:[],
		}
	},
	mounted() {
		this.coursecategoryList()
		this.courselist(1)
	},
	methods:{
		// 选择分类
		selCat(item){
			this.catIdx = item.id
			this.catArr1 = item.childList
			this.catIdx1 = item.childList[0].id
			this.pageNum = 1
			this.courselist(1)
		},
		// 选择分类
		selCat1(id){
			this.catIdx1 = id
			this.pageNum = 1
			this.courselist(1)
		},
		// 分类列表
		async coursecategoryList(){
			let res = await coursecategoryList({});
			if(res.code==200){
				var catIdx = []
				res.data.categoryList.forEach((item)=>{
					item.childList = [{
						id:item.id,
						categoryName:'全部',
					},...item.childList]
				})
				this.catArr = [{
					id:0,
					categoryName:'全部',
					childList:[{
						id:0,
						categoryName:'全部'
					},...res.data.allChildCategoryList],
				},...res.data.categoryList]
				this.catArr1 = this.catArr[0].childList
			}else{this.Tips(res.msg,'error')}
		},
		// 查询课程列表
		async courselist(def){
			if(def){this.pageNum=1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			}
			if(this.keyword){
				data.name = this.keyword
			}
			if(this.catIdx1){
				data.categoryId = this.catIdx1
			}
			let res = await courseappliedCourseList(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.msgList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.courselist()
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
}
.pageTit{
	border-bottom: 1px solid #DDDDDD;
	margin: 0 24px;
	padding-top: 24px;
	padding-bottom: 14px;
	span{
		font-size: 18px;
		color: #3B6492;
		font-weight: bold;
		position: relative;
		&::after{
			content: '';
			width: 100%;
			height: 4px;
			border-radius: 4px;
			background: #3B6492;
			position: absolute;
			bottom: -14px;
			left: 0;
		}
	}
}
.shaixuan{
	// width: 100%;
	padding: 0 24px;
	// background: #fff;
	.catBox{
		padding: 24px 0;
		padding-bottom: 15px;
		// border-bottom: 1px solid #EEEEEE;
	}
	.cat{
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.tit{
			font-size: 14px;
			color: #333333;
		}
		.itm{
			margin-left: 18px;
			height: 28px;
			line-height: 28px;
			padding: 0 8px;
			border-radius: 4px;
			font-size: 14px;
			color: #545964;
			cursor: pointer;
		}
		.a{
			background: #E9F6FF;
			color: #3B6492;
			cursor: pointer;
		}
	}
	.seach{
		width: 100%;
		height: 70px;
		background: #fff;
		padding: 15px 0px;
		padding-top: 0;
		.selzt{
			margin-right: 24px;
			.tit{
				font-size: 14px;
				color: #2C2C2C;
			}
			.el-select{
				width: 200px;
				height: 40px;
				border: 1px solid #DDDDDD;
				margin-left: 12px;
			}
			::v-deep .el-input__inner{
				width: 200px;
				height: 40px;
				border: none;
				background: transparent;
				font-size: 14px;
			}
		}
		.iptBox{
			width: 1332px;
			height: 40px;
			border: 1px solid #DDDDDD;
			margin-right: 12px;
			.sel{
				.el-select{
					width: 97px;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
					font-size: 14px;
				}
			}
			.bor{
				width: 1px;
				height: 20px;
				background: #DDDDDD;
			}
			.ipt{
				width: calc(100% - 100px);
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
		.seachBtn{
			div{
				width: 85px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				&:first-child{
					background: #3B6492;
					border: 1px solid #3B6492;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
	}
}
.biaoge{
	padding: 24px;
	padding-top: 0;
	// background: #fff;
	.table{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 452px;
			}
			.t3{
				width: 210px;
			}
			.t4{
				width: 110px;
			}
			.t5{
				width: 160px;
			}
			.t6{
				width: 129px;
			}
			.t7{
				width: 129px;
			}
			.t8{
				width: 129px;
			}
			.t9{
				width: 124px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>p{
				line-height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				&:last-child{
					border: none;
				}
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 452px;
			}
			.t3{
				width: 210px;
			}
			.t4{
				width: 110px;
			}
			.t5{
				width: 160px;
			}
			.t6{
				width: 129px;
				cursor: pointer;
			}
			.t7{
				width: 129px;
				cursor: pointer;
			}
			.t8{
				width: 129px;
				cursor: pointer;
			}
			.t9{
				width: 124px;
				cursor: pointer;
			}
			.blue{
				color: #3B6492;
			}
			.red{
				color: #FF5F5A;
			}
		}
	}
	.fenye{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 26px;
		.i1{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
		.fyitm{
			width: 32px;
			height: 32px;
			font-size: 12px;
			text-align: center;
			line-height: 32px;
			margin-right: 6px;
			border-radius: 4px;
		}
		.a{
			background: #3B6492;
			color: #fff;
		}
		.i2{
			width: 24px;
			height: 24px;
			margin-right: 19px;
		}
		.linkPage{
			p{
				font-size: 12px;
			}
			.ipt{
				margin: 0 6px;
				width: 42px;
				height: 32px;
				border-radius: 4px;
				background: #F4F4F4;
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
	}
}
</style>